import React from 'react';
import { SCORE_LABELS, scoreTone } from '../../data/compatibility';

export const ScoreBars = ({ scores }) => (
  <ul className="compat-bars">
    {SCORE_LABELS.map(([key, label]) => (
      <li key={key}>
        <span className="compat-bar-label">{label}</span>
        <span className="compat-bar-track" aria-hidden="true">
          <span className={`compat-bar-fill ${scoreTone(scores[key])}`} style={{ width: `${scores[key]}%` }} />
        </span>
        <span className="compat-bar-value">{scores[key]}%</span>
      </li>
    ))}
  </ul>
);

export const ScoreBadge = ({ score, large = false }) => (
  <span className={`compat-score ${scoreTone(score)}${large ? ' large' : ''}`}>{score}%</span>
);

export const Faq = ({ items, title }) => (
  <section className="astro-section">
    <h2>{title}</h2>
    <div className="astro-faq">
      {items.map((item) => (
        <article key={item.q}>
          <h3>{item.q}</h3>
          <p>{item.a}</p>
        </article>
      ))}
    </div>
  </section>
);

export const faqJsonLd = (items) => ({
  '@type': 'FAQPage',
  mainEntity: items.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
});

export const breadcrumbs = (trail) => ({
  '@type': 'BreadcrumbList',
  itemListElement: trail.map(([name, path], index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name,
    item: `https://nowtarot.com${path}`,
  })),
});
